<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <h4>Transfers</h4>
        <v-card flat class="card1">
          <BankTransfer />
          <PersonalTransfer />
        </v-card>
      </v-card>
    </div>
    <div class="Transaction">
      <v-card class="mx-auto card cardv" max-width="344">
        <div class="ImgTrans">
          <div class="trans">
            <h4>Recent Transactions</h4>
            <small @click="navigate('transactionHistory')">see all ></small>
          </div>
        </div>
        <div class="cardRR">
          <RecentTransactions />
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import RecentTransactions from "../components/RecentTransactions";
import BankTransfer from "../components/BankTransfer";
import PersonalTransfer from "../components/PersonalTransfer";
export default {
  metaInfo: {
    title: "Teller/Transfer",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    RecentTransactions,
    BankTransfer,
    PersonalTransfer,
  },
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
  },
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 30px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.bg1 {
  background-color: rgba(187, 107, 217, 0.3);
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
  cursor: pointer;
}
.card1 {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 20px;
  flex-wrap: wrap;
}
.card0 {
  padding-top: 30px;
  height: 250px;
  border-radius: 15px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}
.card0 h4 {
  margin-left: 50px;
}
.cardv {
  height: 550px;
}
.cardRR {
  height: 400px;
  overflow: scroll;
  padding-bottom: 10px;
}
.cardRR::-webkit-scrollbar {
  display: none !important;
}
.init {
  margin-left: 15px;
}
@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }
  .card0 {
    padding: 10px;
    min-height: 350px;
    border-radius: 15px !important;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
